import { FormattedMessage, useIntl } from 'react-intl';

import Button from '@atlaskit/button/new';
import Heading, { type HeadingProps } from '@atlaskit/heading';
import { Box, Stack, Text } from '@atlaskit/primitives';
import { BasePrimitiveProps } from '@atlaskit/primitives/dist/types/components/types';

import { ErrorVector } from '../../assets';

import { messages } from './messages';

export type GenericErrorDisplayProps = {
	iconSize?: 'small' | 'large';
	customMessage?: string;
	refreshButtonLabel?: string;
	headingAs?: HeadingProps['as'];
	xcss?: BasePrimitiveProps['xcss'];
	onRefresh?: () => void;
};

export const GenericErrorDisplay = ({
	iconSize = 'large',
	customMessage,
	refreshButtonLabel,
	headingAs,
	xcss,
	onRefresh,
}: GenericErrorDisplayProps) => {
	const intl = useIntl();

	const buttonLabel = refreshButtonLabel || intl.formatMessage(messages.defaultRefreshButtonLabel);

	return (
		<Box padding="space.400" xcss={xcss}>
			<Stack alignBlock="center" space="space.200" alignInline="center">
				<ErrorVector
					size={iconSize}
					alt={intl.formatMessage(messages.genericErrorGraphicAltText)}
				/>
				<Heading size="medium" as={headingAs}>
					<FormattedMessage {...messages.genericErrorHeading} />
				</Heading>
				{customMessage && <Text>{customMessage}</Text>}
				{onRefresh && (
					<Button appearance="primary" onClick={onRefresh}>
						{buttonLabel}
					</Button>
				)}
			</Stack>
		</Box>
	);
};
